module.exports = __webpack_public_path__ + "img/introducepinxdetail_bodyimage04.2f36e1b7.jpg";